import React                                          from 'react';
import PreviousBtn                                    from 'assets/icons/Previous.svg';
import NextBtn                                        from 'assets/icons/Next.svg';
import { useSelector, useDispatch }                   from "react-redux";
import { fetchNotifications, notificationsSelector }  from 'app/notificationSlice';

export function NotificationFilter() {
  const dispatch = useDispatch();
  const { meta, page } = useSelector(notificationsSelector)

  const handlePageChange = (ind) => {
    let newPage = page+(ind);
    if(newPage > 0 && newPage <= meta.total_pages){
      dispatch(fetchNotifications(newPage));
    }
  }
  
  return (
    <div className="d-flex justify-content-end align-items-end my-6">
      <label className="ml-sm-4 my-2 my-sm-0 mb-0">
        <button className="btn btn-link">
          <img src={ PreviousBtn } alt="previous" className="page-prev-btn" onClick={() => handlePageChange(-1) }/>
        </button>

        <b className="font-size-6 px-2">{page} of {meta.total_pages}</b>

        <button className="btn btn-link">
          <img src={ NextBtn } alt="next" className="page-next-btn" onClick={() => handlePageChange(1) }/>
        </button>
      </label>
    </div>
  );
}

export default NotificationFilter;